/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes.js";
import DashIcon from "components/icons/DashIcon";
import { deleteAccessAndRefreshToken } from "../../utils/auth";
const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "translate-x-96"
      }`}
    >
      <span
        className="absolute end-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="ms-1 mt-1 h-2.5 text-[26px] font-bold uppercase text-navy-700 dark:text-white">
          پنل مدیریت
        </div>
      </div>
      <div className="mb-7 mt-[58px] h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={routes} />
        <button onClick={() => {deleteAccessAndRefreshToken(); window.location = '/auth'}}>
          <div className="relative mb-3 flex hover:cursor-pointer">
            <li
              className="my-[3px] flex cursor-pointer items-center px-8"
            >
              <span
                className={`font-medium text-gray-600`}
              >
               <svg 
               fill="none" height="24" viewBox="0 0 24 24" 
               width="24" xmlns="http://www.w3.org/2000/svg">
               <path d="M17 16L21 12M21 12L17 8M21 12L7 12M13 16V17C13 18.6569 11.6569 20 10 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H10C11.6569 4 13 5.34315 13 7V8" 
               stroke="#A3AED0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
              </span>
              <p
                className={`leading-1 ml-4 flex mr-2 font-medium text-gray-600`}
              >
                خروج
              </p>
            </li>
            {/* {activeRoute(route.path) ? (
              <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
            ) : null} */}
          </div>
        </button>
      </ul>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
